import us from '../../defines';
import {Rectangle} from '../../lib/objects/';
import {setIconState} from '../../toolbar';
import {triggerUScopeEvent} from '../../_uScope';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope.extensions.image-toolbar');
// -------------------------------------------------------------------------------------------------
//    IMAGE TITLE TOOLBAR OBJECT
//
//    Each image has an associated toolbar in its top left corner containing:
//        Active Buttons
//            - a close button
//            - possibly the previous and next slide buttons
//        Indicators
//            - an icon indicating the sample is a positive or negative control, if applicable
//            - an icon indicating the image is pinned, if applicable
//

export default function ImageToolbar (uScope, viewport) {
  var self = this;

  var jVpDiv = viewport.vpDivGet('outer');
  var jToolbar;
  var jToolbarStateDiv;
  var spacerWidth_;
  var jCloseIcon;
  var jPinnedIcon;
  var jControlIcon;
  var jPrevSlideIcon;
  var jNextSlideIcon;

  // ............................................ pinnedSet() public
  this.isPinnedSet = function () {
    if (viewport.sampleTypeIsControl() == false) { // no need to show pinned when is a control sample
      if (viewport.isPinned()) jPinnedIcon.show();
      else jPinnedIcon.hide();
      showStateDiv_(); // show/hide the state indicator div
    } else {
      jPinnedIcon.hide();
    }
  };
  // ............................................ sampleTypeSet() public
  // This function hides or (shows and sets) the sample type icon
  this.sampleTypeSet = function () {
    if (!viewport.sampleTypeIsControl()) {
      jControlIcon.hide();
    } else {
      jControlIcon.removeClass(us.clsTBCONTROL + '-p').removeClass(us.clsTBCONTROL + '-n');
      jControlIcon.addClass(getControlClass_());
      jControlIcon.attr('title', getControlTip_());
      jControlIcon.show();
    }

    nextPrevSlideSet_(); // show/hide the next slide, previous slide buttons
    showStateDiv_(); // show/hide the state indicator div
  };

  // ............................................ nextPrevSlideSet() public
  // This function shows/disables/hides the next slide and previous slide buttons
  var nextPrevSlideSet_ = function () {
    if (viewport.sampleTypeIsControl() == true || // control slides don't show prev/next slide on the image's toolbar
            viewport.isPinned() == true || // pinned slides don't either
            uScope.toolbarCanAddButton('nextPrevSlide') == false) {
      jPrevSlideIcon.hide();
      jNextSlideIcon.hide();
    } else {
      if (uScope.isConfMember() == true) {
        // disable the buttons if in conference as follower
        // TODO: Create some kind of "read-only" mode in uScope and use it to eliminate coupling between
        // TODO: ITB and Conferencing and vice-versa
        setIconState($('.' + us.clsTBPREVSLIDE), us.clsTBPREVSLIDE, 'disabled');
        setIconState($('.' + us.clsTBNEXTSLIDE), us.clsTBNEXTSLIDE, 'disabled');
      } else { // enable and show the buttons
        setIconState($('.' + us.clsTBPREVSLIDE), us.clsTBPREVSLIDE, 'enabled');
        setIconState($('.' + us.clsTBNEXTSLIDE), us.clsTBNEXTSLIDE, 'enabled');
        jPrevSlideIcon.show();
        jNextSlideIcon.show();
      }
    }
  };
    // ............................................ getOffsetRect() public
  this.getOffsetRect = function () {
    var pos = jToolbar.offset();
    var rect = uScope.rootRectGet();
    var rtnOffset = new Rectangle(pos.left - rect.x, pos.top - rect.y, jToolbar.width(), jToolbar.height());

    return rtnOffset;
  };
  // ............................................ showStateDiv_() local
  //    If only the spacer bar is displayed on the state indicator div, hide the div
  var showStateDiv_ = function () {
    if (jToolbarStateDiv.width() > spacerWidth_) jToolbarStateDiv.show();
    else jToolbarStateDiv.hide();
  };
    // ............................................ getControlClass_() local
  var getControlClass_ = function () {
    var ext = '-o';
    var type = viewport.sampleTypeGet();
    if (type == 'positive') { ext = '-p'; } else if (type == 'negative') { ext = '-n'; }

    return us.clsTBCONTROL + ext;
  };
    // ............................................ getControlTip_() local
  var getControlTip_ = function () {
    var type = viewport.sampleTypeGet();
    if (type == 'positive') { return $t('image-positive-control'); } else if (type == 'negative') { return $t('image-negative-control'); }

    return '';
  };
    // ............................................ bindEvents_() local
    // bindEvents_ - This function adds the image toolbar event handlers.
    //
    //    Note that by using the same namespace as the viewport when the
    //    viewport removes its events by namespace, these are also removed.

  var bindEvents_ = function () {
    var namespace = viewport.eventNameSpaceGet();

    jCloseIcon.on('click' + namespace, function (e) {
      if (uScope.getImageCount() > 1) {
        // Initially provided for manual sync to be able to handle the special case when the unpinned viewport
        // is closed.
        uScope.events.trigger('uscope:viewport:toolbar:close-click', viewport);

        triggerUScopeEvent(us.evIMAGECLOSE, {imageId: viewport.getImageId()});
      }
      return false;
    });
    jVpDiv.on('click' + namespace, '.' + us.clsTBNEXTSLIDE + '-e', function (e) {
      triggerUScopeEvent(us.evOPENNEXTSLIDE, {});
      return false;
    });
    jVpDiv.on('click' + namespace, '.' + us.clsTBPREVSLIDE + '-e', function (e) {
      triggerUScopeEvent(us.evOPENPREVSLIDE, {});
      return false;
    });

    $(us.idHashROOT).on(us.evIMAGEUPDATE, function (e, parms) { // set close button icon to enabled if > 1 image open
      setIconState(jCloseIcon, us.clsTBCLOSEIMAGE, ((uScope.getImageCount() == 1) ? 'disabled' : 'enabled'));
      nextPrevSlideSet_(); // disable the next/prev slide buttons if in conference as a member
    });
  };

    // ............................................ init_() local
    //    init_ = This function creates the toolbar, sizes it and adds its event handlers.
  var init_ = function () {
    jToolbar = $('<div/>', {'class': us.clsIMAGETOOLBAR + ' ' + us.clsTRANSPARENT});

    // action buttons .....................................
    jToolbar.append($('<a/>', {
      'class': us.clsTBCLOSEIMAGE + ((uScope.getImageCount() == 1) ? '-d' : '-e') + // set close button icon to enabled if > 1 image open
            ' ' + us.clsTBCLOSEIMAGE + ' ' + us.clsIMAGETOOLBARBTN,
      'title': $t('close-image')
    }));

    // because slide state can change from patient to a control in which case the next/prev slide button is hidden,
    // always load the buttons and hide them if the slide is a control via nextPrevSlideSet_()
    jToolbar.append($('<a/>', {
      'class': us.clsTBPREVSLIDE + ' ' + us.clsTBPREVSLIDE + '-e' + ' ' + us.clsIMAGETOOLBARBTN,
      'title': $t('open-previous-slide')
    }));
    jToolbar.append($('<a/>', {
      'class': us.clsTBNEXTSLIDE + ' ' + us.clsTBNEXTSLIDE + '-e' + ' ' + us.clsIMAGETOOLBARBTN,
      'title': $t('open-next-slide')
    }));

    // status indicators .....................................
    jVpDiv.append(jToolbar); // place the toolbar div in the vp
    jToolbarStateDiv = $('<div/>', {'class': us.clsIMAGETOOLBARSTATE});
    jToolbar.append(jToolbarStateDiv);

    jToolbarStateDiv.append($('<div/>', {'class': us.clsIMAGETOOLBARSPC + ' ' + us.clsIMAGETOOLBARBTN}));
    spacerWidth_ = jToolbarStateDiv.width();

    jToolbarStateDiv.append($('<a/>', {
      'class': us.clsTBPINNED + ' ' + us.clsIMAGETOOLBARBTN,
      'title': $t('status-image-pinned-open')
    }));
    jToolbarStateDiv.append($('<a/>', {
      'class': us.clsTBCONTROL + ' ' + getControlClass_() + ' ' + us.clsIMAGETOOLBARBTN,
      'title': $t('status-image-positive-control')
    }));

    jCloseIcon = jToolbar.find('.' + us.clsTBCLOSEIMAGE);
    jPrevSlideIcon = jToolbar.find('.' + us.clsTBPREVSLIDE + '-e');
    jNextSlideIcon = jToolbar.find('.' + us.clsTBNEXTSLIDE + '-e');

    jPinnedIcon = jToolbarStateDiv.find('.' + us.clsTBPINNED);
    jControlIcon = jToolbarStateDiv.find('.' + us.clsTBCONTROL);

    self.sampleTypeSet(); // update the status of sampleType
    self.isPinnedSet(); // update the status of pinned
    bindEvents_(); // add event handlers
  };

    // ............................................ construction
  init_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-toolbar/image-toolbar.js